import { render, staticRenderFns } from "./m-orm-dialog-tree-select.vue?vue&type=template&id=07ab031a&scoped=true&lang=pug&"
import script from "./m-orm-dialog-tree-select.vue?vue&type=script&lang=js&"
export * from "./m-orm-dialog-tree-select.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07ab031a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTreeview } from 'vuetify/lib/components/VTreeview';
installComponents(component, {VTreeview})
